import React from "react";
import { Helmet } from "react-helmet";
import "./SuccessStories.css";

const stories = [
    { name: "Nick Vrysellas", story: "APTO Websites has completely boosted my brand and now im getting more leads than I ever was!" },
    { name: "Dave Norton", story: "The website is stunning." },
    { name: "Jessica Tran", story: "Switching to APTO's hosting was seamless and my site loads faster than ever. Their support team is always there when I need help!" },
    { name: "Carlos Rivera", story: "The custom website APTO built for me looks professional and has helped me stand out in my market. I love the easy updates and secure hosting." },
    { name: "Emily Chen", story: "APTO's social media management has taken a huge weight off my shoulders. My online presence is growing and I'm seeing more engagement every week!" },
];

// Helper to get initials for avatar
function getInitials(name) {
    return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
}

const SuccessStories = () => (
    <>
        <Helmet>
            <title>Success Stories | AptoWebsites - Real Client Results</title>
            <meta name="description" content="See how real estate professionals have grown their business with AptoWebsites. Read client testimonials and case studies." />
            <meta name="keywords" content="success stories, testimonials, real estate website results, client reviews, AptoWebsites" />
            <meta property="og:title" content="Success Stories | AptoWebsites" />
            <meta property="og:description" content="See how real estate professionals have grown their business with AptoWebsites. Read client testimonials and case studies." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://aptowebsites.com/success-stories" />
            <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
            <link rel="canonical" href="https://aptowebsites.com/success-stories" />
        </Helmet>
        <div className="success-bg">
            <section className="success-hero">
                <h1 className="success-hero-title">Success Stories</h1>
                <p className="success-hero-subtitle">
                    Real results from real estate professionals who trust <span className="brand-highlight">APTO Websites</span>
                </p>
            </section>
            <section className="success-stories-wrapper">
                {/* <h2 className="success-title titles">What Our Clients Say</h2> */}
                <div className="success-stories-container">
                    {stories.map((story, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-avatar">
                                {getInitials(story.name)}
                            </div>
                            <div className="testimonial-content">
                                <p className="testimonial-quote">{story.story}</p>
                                <p className="testimonial-author">— {story.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    </>
);

export default SuccessStories;
